import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {IClientModel} from "../../../models/clients/clients.model";
import {ClientLocationsModel} from "../../../models/client-locations/client-locations.model";
import {ProvincesService} from "../../../models/provinces/provinces.service";
import {ProvincesModel} from "../../../models/provinces/provinces.model";

@Component({
    selector: 'business-location',
    templateUrl: 'business-location.template.html',
    exportAs: 'business-location'
})
export class BusinessLocationComponent {
    @Input('client') @Output('client')
    public client: IClientModel = {
        mailing_location: new ClientLocationsModel(),
        business_location: new ClientLocationsModel(),
    };

    @Input('editMode')
    public editMode = false;

    public provinces = <ProvincesModel[]> [];

    constructor(
        public provincesService: ProvincesService
    ) {
    }

    ngOnInit() {

        this.provincesService.getList()
            .subscribe((res) => {
                this.provinces = res.data;
            });
    }


    copyToMailingAddress() {
        this.client.mailing_location = Object.assign({}, this.client.business_location);
        this.client.mailing_location.province_id =  this.client.province_id; // TODO

    }
}



// WEBPACK FOOTER //
// ./src/app/modules/client-forms/business-location/business-location.component.ts